import { parseFont } from 'css-font-parser';

import { Widget } from '../../utils/enums/embed';
import { STORY_DEFAULT_DISPLAY, STORY_DEFAULT_FONT } from '../constants';
import { StoryDisplay } from '../enums';
import { FEED_DEFAULT_FONT } from '../widgets/feed/constants';

export interface FontComponents {
  'font-size': string;
  'font-family': string[];
  'font-style'?: string;
  'font-variant'?: string;
  'font-weight'?: string;
  'line-height'?: string;
}

const fontComponentsToCssString = (components: FontComponents): string => {
  const {
    'font-style': fontStyle = 'normal',
    'font-variant': fontVariant = 'normal',
    'font-weight': fontWeight = 'normal',
    'font-size': fontSize,
    'line-height': lineHeight,
    'font-family': fontFamily,
  } = components;

  const fontFamilyString = Array.isArray(fontFamily)
    ? fontFamily.join(', ')
    : fontFamily;

  return `${fontStyle} ${fontVariant} ${fontWeight} ${fontSize}${
    lineHeight ? '/' + lineHeight : ''
  } ${fontFamilyString}`;
};

interface Args {
  widget: Widget;
  display?: StoryDisplay;
  font?: string;
}

export const getFont = ({ widget, display, font }: Args): string => {
  const defaultFontComponents =
    widget === Widget.Feed
      ? FEED_DEFAULT_FONT[display || STORY_DEFAULT_DISPLAY]
      : STORY_DEFAULT_FONT[display || STORY_DEFAULT_DISPLAY];

  if (!font) {
    return fontComponentsToCssString(defaultFontComponents);
  }

  try {
    const parsedConfigured = parseFont(font);

    if (!parsedConfigured) {
      return fontComponentsToCssString(defaultFontComponents);
    }

    const merged: FontComponents = {
      'font-size': parsedConfigured['font-size'],
      'font-family': parsedConfigured['font-family'],
      'font-style':
        parsedConfigured['font-style'] ||
        defaultFontComponents['font-style'] ||
        'normal',
      'font-variant':
        parsedConfigured['font-variant'] ||
        defaultFontComponents['font-variant'] ||
        'normal',
      'font-weight':
        parsedConfigured['font-weight'] ||
        defaultFontComponents['font-weight'] ||
        'normal',
      'line-height':
        parsedConfigured['line-height'] ||
        defaultFontComponents['line-height'] ||
        'normal',
    };

    const fontString = fontComponentsToCssString(merged);

    return fontString;
  } catch (error) {
    console.error('Error parsing font', error);
    return fontComponentsToCssString(defaultFontComponents);
  }
};
